var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDelete = function SvgDelete(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none!important",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.657 6.356a8.002 8.002 0 0 0-11.314 11.32 8.09 8.09 0 0 0 11.123.185 7.955 7.955 0 0 0 2.447-4.67A7.97 7.97 0 0 0 20 12.016a7.953 7.953 0 0 0-2.343-5.66zM7.528 7.528a6.415 6.415 0 0 1 8.153-.682.176.176 0 0 1 .021.267l-8.59 8.594a.176.176 0 0 1-.21.03.177.177 0 0 1-.057-.05 6.333 6.333 0 0 1 .683-8.159zm8.971 8.976a6.345 6.345 0 0 1-8.154.682.175.175 0 0 1-.021-.267l8.591-8.595a.177.177 0 0 1 .267.02 6.333 6.333 0 0 1-.682 8.16z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDelete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "delete.4be8a6a45fdb7af199949982874db0a6.svg";